import { SCROLL_DURATION, scrollEasing, subscribeToScroll, scrollTo, getScrollInstance, getCurrentScrollValues } from '../core/ScrollService.js';
const initScrollUp = () => {
    const button = document.querySelector('.top-button')

    if (button && getScrollInstance()) {
        const checkScroll = ({ scroll: scrollY }) => {
            if (scrollY > window.innerHeight) {
                button.classList.add('visible')
            } else {
                button.classList.remove('visible')
            }
        }

        subscribeToScroll(checkScroll)
        checkScroll(getCurrentScrollValues())

        button.addEventListener('click', () => {
            getScrollInstance().scrollTo(0, { duration: SCROLL_DURATION, easing: scrollEasing, force: true });
        })
    }
};

export { initScrollUp };
